import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiStopQuickInfo extends Layout {
    sourceEdiStop: DataSource;
    table1: Table;
}
